  lightbox.option({
    'resizeDuration': 100,
    'wrapAround': true,
    'fadeDuration': 200
  });
  
let scrollPosition = 0;
let checkLightboxInterval;

// On lightbox open
$('a[data-lightbox]').on('click', function() {
  scrollPosition = $(window).scrollTop();
  $('body').addClass('lightbox-open').css('top', -scrollPosition + 'px');

  // Start checking if lightbox is closed
  checkLightboxInterval = setInterval(function() {
    if (!$('#lightbox').is(':visible')) {
      // Lightbox is now closed
      $('body').removeClass('lightbox-open').css('top', '');
      window.scrollTo(0, scrollPosition);

      clearInterval(checkLightboxInterval); // Stop checking
    }
  }, 200); // Check every 200ms
});